import type { Entry, EntryFields, EntryFieldTypes, EntrySkeletonType, UnresolvedLink } from 'contentful';
import type { ColorField, SchemaProps, WithSectionName, WithStatsigFlag, WithTypename } from 'libs/contentful/types';
import type { KeyLinePosition, Margins } from 'types/constants';
import type { CtaRuntimeEntry, CtaSkeleton } from 'components/shared/CTA/types';
import type { LinkedIconSkeleton } from 'components/shared/LinkedIcon/types';

export enum CtaAddOnVariant {
  ButtonOnly = 'Button Only',
  Copy = 'Copy',
}

export enum CtaAddOnAlignment {
  Left = 'Left',
  Right = 'Right',
  Centered = 'Centered',
}

export interface CtaAddOnFields {
  internalName: EntryFieldTypes.Symbol;
  sectionName?: EntryFieldTypes.Symbol;
  keyLine?: EntryFieldTypes.Symbol<KeyLinePosition>;
  headline?: EntryFieldTypes.RichText;
  cta: EntryFieldTypes.EntryLink<CtaSkeleton | LinkedIconSkeleton>;
  margins: EntryFieldTypes.Symbol<Margins>;
  color: EntryFieldTypes.Object<ColorField>;
  variant: EntryFieldTypes.Symbol<CtaAddOnVariant>;
  alignment?: EntryFieldTypes.Symbol<CtaAddOnAlignment>;
  transparentBackground?: EntryFieldTypes.Boolean;
  pinCtaAboveFold?: EntryFieldTypes.Boolean;
  schema?: EntryFieldTypes.Object<{ [K in keyof SchemaProps]: SchemaProps[K] & EntryFields.Object }>;
}

export type CtaAddOnSkeleton = EntrySkeletonType<CtaAddOnFields, 'copyAddOnWithButton'>;

export type CtaAddOnProps = Entry<CtaAddOnSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'> &
  WithTypename<'CopyAddOnWithButton'> &
  WithStatsigFlag &
  WithSectionName;

export interface CtaAddOnRuntimeFields extends Omit<CtaAddOnProps['fields'], 'cta'> {
  cta: CtaRuntimeEntry | Entry<LinkedIconSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'> | UnresolvedLink<'Entry'> | undefined;
}

export interface CtaAddOnRuntimeProps extends Omit<CtaAddOnProps, 'fields'> {
  fields: CtaAddOnRuntimeFields;
}
